import { ProjectDetailPage } from "./ProjectDetail.js";
import { ProjectFormPage } from "./ProjectForm.js";
import { ProjectsListPage } from "./ProjectList.js";
import { TeamPlanner } from "./TeamPlanner.js";

export const projectsRoutes = [
  { path: "projects", element: <ProjectsListPage /> },
  { path: "planner", element: <TeamPlanner /> },
  { path: "projects/new", element: <ProjectFormPage /> },
  { path: "projects/:id", element: <ProjectDetailPage /> },
  { path: "projects/:id/edit", element: <ProjectFormPage /> },
];
